<template>
  <div>
    <status-string
      v-if="status === OrderStatus.Confirmed"
      class="text-green"
      :text="BOOK_STATUSES[OrderStatus.Confirmed]"
    />
    <status-string v-if="status === OrderStatus.Avoided" class="text-red" :text="BOOK_STATUSES[OrderStatus.Avoided]" />
    <status-string
      v-if="status === OrderStatus.NotConfirmed"
      class="text-primary"
      :text="BOOK_STATUSES[OrderStatus.NotConfirmed]"
    />
  </div>
</template>

<script setup lang="ts">
import StatusString from '@/core/components/common/StatusString.vue';
import { OrderStatus } from '@/graphql/generated';
import { BOOK_STATUSES } from '@/parts/books/utils/consts';

defineProps<{
  status: OrderStatus;
}>();
</script>

<style scoped lang="scss"></style>
